module.exports = __webpack_public_path__ + "img/tools_Expatriate_Practice_Report.76f84a8d.jpg";